import React from 'react';
import { Router } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css';
import { history } from './helpers';
import { Routes } from './components';

const App = () => {
  return (
    <Router history={history}>
      <Routes />
    </Router>
  );
};

export default App;
